'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import WoocommerceServies from '@/components/technologies/woocommerce-demand';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Get Engaging, Interactive, Dynamic, and Profitable E-commerce Solutions with Our WooCommerce Development Services"
                alt="WooCommerce Development"
                title="WooCommerce Development"
                width={1090}
                height={604}
                path={'woocommerce-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                WooCommerce <div>Development Company</div>
            </TechHero>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="WooCommerce" />
            <ContetVideoSection title="Custom WooCommerce Services at Moweb">
                <>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        Being an open-source e-commerce plugin for WordPress, WooCommerce is highly suitable for small to
                        large-sized businesses and enterprises to build complex yet interactive websites. Our WooCommerce
                        developer specializes in building, customizing, and implementing WooCommerce platforms for multiple
                        domains. Having an in-depth understanding of various WooCommerce factors including user experience, user
                        interface, plugins, and extensions helps us to design an eye-pleasing online store; driving more audience
                        to your website. Withholding 15+ years of rich experience e-commerce domain, we can undoubtedly leverage
                        the best WooCommerce website design that can surely make an e-commerce storefront stand out from your
                        competitors.
                    </p>
                </>
            </ContetVideoSection>
            <WoocommerceServies />
            <HireProcess
                bg="bg-woo-commerce"
                pageTitle="Want to Build Your Next WooCommerce-Powered Online Store?"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using WooCommerce."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For WooCommerce Development?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best WooCommerce Developers"
                desc="Our team of dedicated WooCommerce developers is known for their exceptional productivity and cost-effectiveness. We take pride in offering a flexible working model that allows you to hire dedicated WooCommerce developers to meet your specific needs."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
